module.exports = __webpack_public_path__ + "img/pieds-bebe.2ca0b8dc.jpg";